<div class="context-menu">
  <div class="icons-top">
    @if (!isActive()) {
      <button
        type="button"
        class="button-reset sidebar-icon-only"
        tabindex="0"
        data-testid="btn-conversation-sidebar-collapse">
        <orbit-fa-icon id="collapse-button" [iconName]="getCollapseIcon()" />
      </button>
      @if (isCollapsed()) {
        <div class="collapsed-text" data-testid="conversation-sidebar-label">{{ label() }}</div>
        @if (notifications() > 0 || dot()) {
          <orbit-notification
            [amount]="notifications()"
            data-testid="conversation-sidebar-notification" />
        }
      }
    } @else {
      @if (isCloseable()) {
        <button
          type="button"
          class="button-reset sidebar-icon-only-wrapper"
          [ngClass]="{ active: activeIcon() === SidebarButtonTypeEnum.Close }"
          (click)="sidebarClicked(SidebarButtonTypeEnum.Close, $event)"
          (keydown)="onSidebarKeyDown($event, SidebarButtonTypeEnum.Close)"
          [title]="'SHARED.CONVERSATION_SIDEBAR.CLOSE_TITLE' | translate"
          tabindex="0"
          data-testid="btn-conversation-sidebar-close">
          <orbit-fa-icon class="sidebar-icon-only-x" [iconName]="xMarkIcon" />
        </button>
      }
      @if (!isConversationArchived()) {
        <button
          type="button"
          class="button-reset sidebar-icon-only-wrapper"
          [ngClass]="{ active: activeIcon() === SidebarButtonTypeEnum.Notify }"
          (click)="sidebarClicked(SidebarButtonTypeEnum.Notify, $event)"
          (keydown)="onSidebarKeyDown($event, SidebarButtonTypeEnum.Notify)"
          [title]="'SHARED.CONVERSATION_SIDEBAR.NOTIFY_TITLE' | translate"
          tabindex="0"
          data-testid="btn-conversation-sidebar-notify">
          <orbit-fa-icon [iconName]="bell" />
        </button>
      }
      <button
        type="button"
        class="button-reset sidebar-icon-only-wrapper"
        [ngClass]="{ active: activeIcon() === SidebarButtonTypeEnum.Participants }"
        (click)="sidebarClicked(SidebarButtonTypeEnum.Participants, $event)"
        (keydown)="onSidebarKeyDown($event, SidebarButtonTypeEnum.Participants)"
        [title]="'SHARED.CONVERSATION_SIDEBAR.SHOW_PARTICIPANTS' | translate"
        tabindex="0"
        data-testid="btn-conversation-sidebar-participants">
        <orbit-fa-icon [iconName]="userGroupIcon" />
      </button>
      <button
        type="button"
        class="button-reset sidebar-icon-only-wrapper"
        [ngClass]="{ active: activeIcon() === SidebarButtonTypeEnum.Share }"
        (click)="sidebarClicked(SidebarButtonTypeEnum.Share, $event)"
        (keydown)="onSidebarKeyDown($event, SidebarButtonTypeEnum.Share)"
        [title]="'SHARED.CONVERSATION_SIDEBAR.LINK_TITLE' | translate"
        tabindex="0"
        data-testid="btn-conversation-sidebar-share">
        <orbit-fa-icon class="sidebar-icon-share" [iconName]="linkIcon" />
      </button>
      @if (!isConversationArchived()) {
        <button
          type="button"
          class="button-reset sidebar-icon-only-wrapper"
          [ngClass]="{ active: activeIcon() === SidebarButtonTypeEnum.Archive }"
          (click)="sidebarClicked(SidebarButtonTypeEnum.Archive, $event)"
          (keydown)="onSidebarKeyDown($event, SidebarButtonTypeEnum.Archive)"
          [title]="'SHARED.CONVERSATION_SIDEBAR.ARCHIVE' | translate"
          tabindex="0"
          data-testid="btn-conversation-sidebar-archive">
          <orbit-fa-icon class="sidebar-icon-archive" [iconName]="archiveIcon" />
        </button>
      } @else {
        <button
          type="button"
          class="button-reset sidebar-icon-only-wrapper"
          [ngClass]="{ active: activeIcon() === SidebarButtonTypeEnum.Unarchive }"
          (click)="sidebarClicked(SidebarButtonTypeEnum.Unarchive, $event)"
          (keydown)="onSidebarKeyDown($event, SidebarButtonTypeEnum.Unarchive)"
          [title]="'SHARED.CONVERSATION_SIDEBAR.UNARCHIVE' | translate"
          tabindex="0"
          data-testid="btn-conversation-sidebar-unarchive">
          <orbit-fa-icon class="sidebar-icon-archive" [iconName]="unarchiveIcon" />
        </button>
      }
      <button
        type="button"
        class="button-reset sidebar-icon-only-wrapper"
        [ngClass]="{ active: activeIcon() === SidebarButtonTypeEnum.Flag }"
        (click)="sidebarClicked(SidebarButtonTypeEnum.Flag, $event)"
        (keydown)="onSidebarKeyDown($event, SidebarButtonTypeEnum.Flag)"
        [title]="'SHARED.CONVERSATION_SIDEBAR.FLAG' | translate"
        tabindex="0"
        data-testid="btn-conversation-sidebar-flag">
        @if (selectedFlagColor()) {
          <orbit-fa-icon
            class="flag"
            [ngClass]="'flag-' + selectedFlagColor()"
            [iconName]="filledFlagIcon" />
        } @else {
          <orbit-fa-icon [iconName]="emptyFlag" />
        }
      </button>
      @if (!isConversationArchived()) {
        @if (isConversationLocked()) {
          <button
            type="button"
            class="button-reset sidebar-icon-only-wrapper"
            (click)="sidebarClicked(SidebarButtonTypeEnum.Unlock, $event)"
            (keydown)="onSidebarKeyDown($event, SidebarButtonTypeEnum.Unlock)"
            [title]="'SHARED.CONVERSATION_SIDEBAR.UNLOCK' | translate"
            tabindex="0"
            data-testid="btn-conversation-sidebar-unlock">
            <orbit-fa-icon class="sidebar-icon-archive" [iconName]="unlock" />
          </button>
        } @else {
          <button
            type="button"
            class="button-reset sidebar-icon-only-wrapper"
            (click)="sidebarClicked(SidebarButtonTypeEnum.Lock, $event)"
            (keydown)="onSidebarKeyDown($event, SidebarButtonTypeEnum.Lock)"
            [title]="'SHARED.CONVERSATION_SIDEBAR.LOCK' | translate"
            tabindex="0"
            data-testid="btn-conversation-sidebar-lock">
            <orbit-fa-icon class="sidebar-icon-archive" [iconName]="lockIcon" />
          </button>
        }
      }
    }
  </div>
  @if (isDraggable()) {
    <div cdkDragHandle class="icons-middle">
      <orbit-fa-icon
        class="grab-icon"
        [iconName]="gripVertical"
        data-testid="conversation-sidebar-drag-handle" />
    </div>
  }
</div>
